import axios from "axios";
import fileDownload from "js-file-download";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import GeneralInfoServices from "./GeneralInfo.services";
import * as FileSaver from "file-saver";
// import {
//   downloadDocument,
//   getBase64,
// } from "../../../components/gestorDocumental/GestorDocumental";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getGeneralInfo = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_GENERAL_INFO,
      payload: true,
    });
    debugger;
    const resp = await GeneralInfoServices.getGeneralInfo(filters);
    dispatch({
      type: actions.GET_GENERAL_INFO,
      payload: {
        generalInfos: resp.data.data,
        generalInfosLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.GENERAL_INFO_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.GENERAL_INFO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_GENERAL_INFO,
      payload: false,
    });
  }
};

export const getDescriptor = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_DESCRIPTOR,
      payload: true,
    });
    debugger
    const resp = await GeneralInfoServices.getDescriptor(filters);
    dispatch({
      type: actions.GET_DESCRIPTOR,
      payload: resp.data.data[0],
      // generalInfosLength: resp.data.count,
    });
    dispatch({
      type: actions.FAIL_DESCRIPTOR,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FAIL_DESCRIPTOR,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DESCRIPTOR,
      payload: false,
    });
  }
};

export const resetGeneralInfo = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_GENERAL_INFO,
      payload: true,
    });
    dispatch({
      type: actions.GET_GENERAL_INFO,
      payload: {
        generalInfos: [],
        generalInfosLength: 0,
      },
    });
    dispatch({
      type: actions.GENERAL_INFO_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.GENERAL_INFO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_GENERAL_INFO,
      payload: false,
    });
  }
};

export const getGeneralInfoById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_GENERAL_INFO_BY_ID,
      payload: true,
    });
    const resp = await GeneralInfoServices.getGeneralInfoById(id);
    dispatch({
      type: actions.GET_GENERAL_INFO_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.GENERAL_INFO_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.GENERAL_INFO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_GENERAL_INFO_BY_ID,
      payload: false,
    });
  }
};

export const saveGeneralInfo =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_GENERAL_INFO,
        payload: true,
      });
      const resp = await GeneralInfoServices.saveGeneralInfo(data);
      const { generalInfos, generalInfosLength } = getState().generalInfo;
      const _generalInfo = [...generalInfos, resp.data];
      dispatch({
        type: actions.GET_GENERAL_INFO,
        payload: {
          generalInfos: _generalInfo,
          generalInfosLength: generalInfosLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_GENERAL_INFO,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_GENERAL_INFO,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_GENERAL_INFO,
        payload: false,
      });
    }
  };

export const editGeneralInfo =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_GENERAL_INFO,
        payload: true,
      });
      const resp = await GeneralInfoServices.editGeneralInfo(id, data);
      const { generalInfos, generalInfosLength } = getState().generalInfo;
      const dataT = resp.data;
      generalInfos[index] = dataT;
      dispatch({
        type: actions.GET_GENERAL_INFO,
        payload: {
          generalInfos: generalInfos,
          generalInfosLength: generalInfosLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_GENERAL_INFO,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data: [
          {
            funcion_descriptor: dataT.posicion,
            tipo_mensaje: "Jefe actualiza descriptor",
          },
        ],
      };
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_GENERAL_INFO,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_GENERAL_INFO,
        payload: false,
      });
    }
  };

export const editGeneralInfoById =
  (data, id, setValidated) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_GENERAL_INFO_BY_ID,
        payload: true,
      });
      const resp = await GeneralInfoServices.editGeneralInfo(id, data);
      const dataT = resp.data;
      dispatch({
        type: actions.GET_GENERAL_INFO_BY_ID,
        payload: dataT,
      });
      // const { generalInfos, generalInfosLength } = getState().generalInfo;
      // generalInfos[index] = resp.data;
      // dispatch({
      //   type: actions.GET_GENERAL_INFO,
      //   payload: {
      //     generalInfos: generalInfos,
      //     generalInfosLength: generalInfosLength,
      //   },
      // });
      setValidated(false);
      dispatch({
        type: actions.FORM_FAIL_GENERAL_INFO,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data: [
          {
            funcion_descriptor: dataT.posicion,
            tipo_mensaje: "Jefe actualiza descriptor",
          },
        ],
      };
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_GENERAL_INFO,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_GENERAL_INFO_BY_ID,
        payload: false,
      });
    }
  };

export const editDescriptor = (data, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DESCRIPTOR,
      payload: true,
    });
    // debugger
    const resp = await GeneralInfoServices.editDescriptor(id, data);
    // const { descriptorAcepta } = getState().descriptorAcepta;
    // const dataT = resp.data;
    // descriptorAcepta[index] = dataT;
    //  console.log("data",resp.data)
    let _resp = resp.data;
    resp.acepto_descriptor = true;
    dispatch({
      type: actions.GET_DESCRIPTOR,
      payload: _resp,
    });
    dispatch({
      type: actions.FORM_FAIL_DESCRIPTOR,
      payload: "",
    });
    // setShowModal(false);
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
    // const _data = {
    //   data: [
    //     {
    //       funcion_descriptor: dataT.posicion,
    //       tipo_mensaje: "Jefe actualiza descriptor",
    //     },
    //   ],
    // };
    // await GeneralInfoServices.mailSendGeneralInfo(_data);
    // toastr.success(messages.correoEnviado, "", {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_DESCRIPTOR,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DESCRIPTOR,
      payload: false,
    });
  }
};

export const deleteGeneralInfo = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_GENERAL_INFO,
      payload: true,
    });
    await GeneralInfoServices.deleteGeneralInfo(id);
    const { generalInfos, generalInfosLength } = getState().generalInfo;
    generalInfos.splice(index, 1);
    dispatch({
      type: actions.GET_GENERAL_INFO,
      payload: {
        generalInfos: generalInfos,
        generalInfosLength: generalInfosLength - 1,
      },
    });
    dispatch({
      type: actions.GENERAL_INFO_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.GENERAL_INFO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_GENERAL_INFO,
      payload: false,
    });
  }
};

export const getDescriptorManual =
  (id, filename, setLoader, history) => async (dispatch, getState) => {
    try {
      // dispatch({
      //   type: actions.LOADING_DESCRIPTOR_MANUAL,
      //   payload: true,
      // });
      setLoader(true);
      // const resp = await GeneralInfoServices.getDescriptorManual(id);
      // dispatch({
      //   type: actions.DOC_DESCRIPTOR,
      //   payload: resp.data,
      // });
      // downloadDocument(
      //   `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${resp.data.documento}`,
      //   `${filename}.docx`
      // );
      const newWindow = window.open("", "_blank");

      // Update the URL in the new window or tab
      newWindow.location.href = `/descriptores-perfiles/descargar-descriptor/${id}/${filename}`;

      // Update the URL in the current window using history.push
      // history.push(
      //   `/descriptores-perfiles/descargar-descriptor/${id}/${filename}`
      // );
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      // dispatch({
      //   type: actions.FORM_FAIL_GENERAL_INFO,
      //   payload: message,
      // });
      toastr.error(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      setLoader(false);
      // dispatch({
      //   type: actions.LOADING_DESCRIPTOR_MANUAL,
      //   payload: false,
      // });
    }
  };

export const getBase64Document = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DESCRIPTOR_MANUAL,
      payload: true,
    });
    debugger
    const resp = await GeneralInfoServices.getDescriptorManual(id);
    dispatch({
      type: actions.DOC_DESCRIPTOR,
      payload: resp.data,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.FORM_FAIL_GENERAL_INFO,
    //   payload: message,
    // });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DESCRIPTOR_MANUAL,
      payload: false,
    });
  }
};

export const getPDFDocument = (id, params) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PDF_DESCRIPTOR,
      payload: true,
    });
    debugger
    const resp = await GeneralInfoServices.getPDFDocument(id, params);
    console.table(resp.data.proceso_realizado[0]);
    dispatch({
      type: actions.PDF_DESCRIPTOR,
      payload: resp.data.proceso_realizado[0],
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.FORM_FAIL_GENERAL_INFO,
    //   payload: message,
    // });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PDF_DESCRIPTOR,
      payload: false,
    });
  }
};
